<template>
  <div>
    <h2 class="-sr-only">{{ $t('js.layers.title') }}</h2>

    <rui-empty v-if="layers.length === 0" :content="$t('js.garden.layers.no_layers')" inline />

    <rui-list-item v-for="layer in layers"
                   :key="layer.id"
                   :data-layer-id="layer.id"
                   :caption="layer.name"
                   class="-mhs"
                   static
                   @choose="notifyActiveLayer(layer)">
      <template #left>
        <rui-button v-if="visibleLayers && visibleLayers.indexOf(layer.id) === -1" icon="eye-slash" @click="notifyVisibilityChange(layer.id)" />
        <rui-button v-else icon="eye" @click="notifyVisibilityChange(layer.id)" />
      </template>
    </rui-list-item>

    <rui-list-item :caption="$t('js.layers.background_layer')" class="-mhs" static>
      <template #left>
        <rui-button :icon="map.hideBackground ? 'eye-slash' : 'eye'" @click="toggleBackgroundVisibility" />
      </template>
    </rui-list-item>
  </div>
</template>

<script>
import RuiButton from '@experiments-labs/rise_ui/src/components/Button/Button.vue'
import RuiEmpty from '@experiments-labs/rise_ui/src/components/DataDisplay/Empty/Empty.vue'
import RuiListItem from '@experiments-labs/rise_ui/src/components/ListItem/ListItem.vue'

export default {
  name: 'GardenLayers',
  emits: [
    'toggle',
    'activate',
  ],
  components: { RuiButton, RuiListItem, RuiEmpty },
  props: {
    visibleLayers: { required: false, type: Array, default: null },
  },
  computed: {
    layers () { return this.$store.getters.layers },
    map () { return this.$store.getters.currentMap },
  },
  methods: {
    notifyVisibilityChange (id) { this.$emit('toggle', id) },
    notifyActiveLayer (layer) { this.$emit('activate', layer) },
    toggleBackgroundVisibility () {
      this.map.hideBackground = !this.map.hideBackground
      this.$emitBus('change-background-layer-visibility')
    },
  },
  created () {
    this.notifyActiveLayer(this.layers[0])
    // Deactivate layers when specified
    this.$nextTick(() => {
      this.layers.forEach((l) => { if (!l.visibleByDefault) this.notifyVisibilityChange(l.id) })
    })
  },
}
</script>
